import { IUserInfo, TokenBalance, ChainBalance } from '@/types/user';
import { get, post, WalletType } from '@web3/base-utils';

export interface BalanceParams {
  chainId?: number;
  chainCode?: string;
  walletId?: string;
  walletType: WalletType;
  walletAddress: string;
  tokenAddress?: string;
}

export interface BatchQueryParams {
  type: number;
  walletId: string;
  addressChain: {
    chainId?: number;
    chainCode?: string;
    address: string;
    chainType?: number;
    custodyPubKey?: string;
  }[];
}

export interface BatchQueryAddressDetail {
  address: string;
  chainId: string;
  chainCode: string;
  amountUsd: string;
  tokenInfo: Array<{
    chainId: string;
    chainCode: string;
    name: string;
    contract: string;
    decimals: number;
    iconDayUrl: string;
    iconNightUrl: string;
    price: string;
    balance: string;
    balanceUsd: string;
    type: number;
  }>;
}
export type BatchQueryResult = {
  totalAmountUsd: string;
  addressDetail: Array<BatchQueryAddressDetail>;
};

export const getUserInfo = () => {
  return get<IUserInfo>(`/v2/private/user/profile`, {});
};
/** 获取链余额 */
export const getChainBalance = (params?: {
  walletAddress?: string;
  chainType?: number;
}) => {
  return get<ChainBalance>('/spot/api/web3/wallet/v2/asset/allChainAmount', {
    params,
  });
};
/** 云钱包获取币种余额列表 */
export const getCloudAssetBalanceList = (params: RequestData) => {
  return get<TokenBalance[]>(
    '/spot/api/web3/wallet/v2/asset/balanceList',
    params
  );
};
/**
 * 插件钱包获取币种余额列表  query
 * */
export const getExtensionAssetBalanceList = (data: BatchQueryParams) => {
  // 因为都是连主网插件，所以这个接口只能拿主网数据
  return post<BatchQueryResult>(
    `/web3/wallet/v1/private/mgmt/asset/batchQuery`,
    data
  );
};
